import fiscalInstance from '../../instance'

const savePdfMonthlyReport = (reportId, traceId, locale) => {
	return fiscalInstance.post(
		'/cashRegisterClose/monthlyReports/' + reportId + '/save-pdf',
		{ traceId, locale },
	)
}

export default savePdfMonthlyReport
